import Link from 'next/link';
import React from 'react';

export const Footer = (): JSX.Element => {
  return (
    <div className="w-full bg-white">
      {/* <div className="laptop:px-164 mobile:px-24 max-w-1440 mx-auto flex desktop:flex-row laptop:flex-row tablet:flex-row mobile:flex-col mb-40">
        <Link href={'/'}>
          <a>
            <SketchNoteLogoTwoIcon className="text-white mb-48 desktop:mr-90 tablet:mr-64" />
          </a>
        </Link>
        <div className="flex-grow flex flex-row flex-wrap desktop:justify-evenly  tablet:justify-between mobile:justify-between">
          <div className="text-gray-999 text-sm flex flex-col items-baseline desktop:mb-0 mobile:mb-32 tablet:mb-32">
            <p className="font-semibold text-primary-800 text-lg mb-24 ">Product</p>
            <Link href={'/product'}>
              <a className="mb-16">Product home</a>
            </Link>
            <Link href={'/learn'}>
              <a className="mb-16">Learn</a>
            </Link>

            <Link href={'/document-management-system'}>
              <a className="mb-16">Create</a>
            </Link>
            <Link href={'/autocomplete-legal-documents'}>
              <a className="mb-16">Legal</a>
            </Link>
            <Link href={'/storage'}>
              <a className="mb-16">Documents</a>
            </Link>
            <Link href={'/online-collaboration-tool'}>
              <a className="mb-16">Boards</a>
            </Link>
            <Link href={'/ai-recommendations'}>
              <a className="mb-16">AI</a>
            </Link>
            <Link href={'/gamification'}>
              <a className="mb-16">Gamification</a>
            </Link>

            <Link href={'/how-it-works'}>
              <a className="mb-16">How it works</a>
            </Link>
            <Link href={'/meet-the-mentors'}>
              <a className="mb-16">Meet the mentors</a>
            </Link>
            <Link href={'/catalog'}>
              <a className="mb-16">Template library</a>
            </Link>
            <Link href={'/pricing'}>
              <a className="">Pricing</a>
            </Link>
          </div>
          <div className="text-gray-999 text-sm flex flex-col items-baseline pr-24">
            <p className="font-semibold text-primary-800 text-lg mb-24 mobile:mr-12">Company</p>
            <Link href={'/about'}>
              <a className="mb-16">About</a>
            </Link>
            <Link href={'/grants'}>
              <a className="mb-16">Grants</a>
            </Link>

            <Link href={'/help'}>
              <a className="mb-16">Help</a>
            </Link>
            <Link href={'/blog/'}>
              <a className="mb-16">Blog</a>
            </Link>
            <Link href={'https://sketchnote.typeform.com/contact-us'}>
              <a className="mb-16">Contact</a>
            </Link>
            <Link href={'/sketchnote-funding'}>
              <a className="mb-16">Sketchnote funding</a>
            </Link>
            <Link href={'/sketchnote-100k-challenge'}>
              <a className="mb-16">Sketchnote $100k challenge</a>
            </Link>
          </div>

          <div className="text-gray-999 text-sm flex flex-col items-baseline">
            <p className="font-semibold text-primary-800 text-lg mb-24 ">Social</p>
            <a
              target="_blank"
              href="https://twitter.com/SketchnoteCo"
              className="mb-16"
              rel="noopener noreferrer"
            >
              Twitter
            </a>
            <a
              target="_blank"
              href="https://www.facebook.com/SketchnoteCo"
              className="mb-16"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
            <a
              target="_blank"
              href="https://www.linkedin.com/company/sketchnote"
              className="mb-16"
              rel="noopener noreferrer"
            >
              Linkedin
            </a>
            <a
              target="_blank"
              href="https://www.instagram.com/SketchnoteCo"
              className="mb-16 text-left"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
            <a
              target="_blank"
              href="https://www.youtube.com/channel/UC8S-UIq8F-DuAVeQRPAoCcA"
              className="mb-16 text-left"
              rel="noopener noreferrer"
            >
              Youtube
            </a>
            <a
              target="_blank"
              href="https://community.sketchnote.co"
              className="mb-16 text-left"
              rel="noopener noreferrer"
            >
              Community
            </a>
          </div>
        </div>
      </div> */}

      <div className="  py-8 text-gray-400 text-sm bg-primary-700">
        <div className="max-w-1440 mx-auto laptop:px-164 mobile:px-24">
          <div className="py-16 border-b">
            Built by musicians, pharmacists, artists, journalists, engineers, dreamers, and other
            first career choices&nbsp;
            <img
              src="https://res.cloudinary.com/samvibes/image/upload/v1626938650/landing/heart.png"
              alt=""
              className="h-12 w-15 inline-block"
            />
          </div>

          <div className="py-16 flex desktop:flex-row laptop:flex-col tablet:flex-col mobile:flex-col  justify-between">
            <div className="mobile:mb-8 desktop:mb-0">
              © 2021 Sketchnote Inc.&nbsp;All rights reserved.
            </div>
            <div className="flex flex-wrap">
              <Link href={'/privacy-policy'}>
                <a>Privacy Policy</a>
              </Link>
              <Link href={'/terms-of-service'}>
                <a className="mx-16 block">Terms of service</a>
              </Link>
              <Link href={'/cookies-policy'}>
                <a className="block">Cookies policy</a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
